// extracted by css-extract-rspack-plugin
export default {"policyCardButton":"yY2gH","policyCardButtonInner":"ZiPhJ","policyCardLabel":"Dpj6R","optionsButton":"UdfQD"};